module.exports = __webpack_public_path__ + "48bd7cfac26b69463eca574486bdb97c.png";